import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * Refunded payments — inherits from all-transactions, filtered on the payment's
 * own refund status.
 *
 * PD-15117: this list previously defaulted `transactionType` to Refund, which
 * could never match. The list is built on payment SUMMARIES and that filter
 * tested the summary's ORIGIN transaction, but a refund is never an origin —
 * it is a child in the payment chain and folds into the summary of the payment
 * it reversed. The tab therefore always read zero while real refunds existed.
 *
 * The row here is the original payment showing that it was refunded, which is
 * what this list can represent: the Refunded amount and any failed refund or
 * void attempts are already columns on it (PD-15091). Same family as PD-15108.
 */
export const refundTransactionsList: ListBuilderList = {
	id: 'default-transaction-refunds',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Refunds',
	type: 'default',
	active: true,
	sortOrder: 6,
	description: 'Payments that have been refunded, in whole or in part',
	defaultSortId: 'column-transaction-dates-desc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionStatus: {
			defaultValue: [
				{ id: 'Refunded', label: 'Refunded' },
				{ id: 'Partially refunded', label: 'Partially Refunded' },
				{ id: 'Processing refund', label: 'Processing Refund' },
			],
		},
	},
};
